import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserList from '../../components/UserList'
import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import axios from 'axios'
import { Preloader } from '../../components/Chart/index'
import './style.css'

import Multi from '../../components/Multi'
import UserRolesService from '../../lib/services/userRole/UserRolesService'

class Settings extends Component {
    state = {
        loading: false,
        data: [],
        roles: [],
        showEdit: true
    }

    componentDidMount() {
        this.setState({ loading: true }, () => {
            axios.get('/user').then(response => {
                this.setState({ data: response.data.body, loading: false })
            })
            axios.get('/role').then(response => {
                this.setState({ roles: response.data.body, loading: false })
            })
        })

        // check if the user can see edit column
        let userService = new UserRolesService()
        userService.isEnabled('/user', 'PATCH').then(active => {
            this.setState({ showEdit: active })
        })
    }

    // Sub Partners CRUD

    onChange(event, row, index) {
        let obj = this.state.data
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
        console.log('onSubPartnersChange', event, row, index, value)
        obj[index][event.target.id] = value
        this.setState(obj)
    }

    onAdd() {
        let partnerId = this.props.partnerId
        if (this.props.partnerMasquerading && this.props.partnerMasquerading.partnerId) {
            partnerId = this.props.partnerMasquerading.partnerId
        }

        console.log('on add')
        let obj = this.state.data
        obj.push({
            new: true,
            partnerId: partnerId,
            username: '',
            name: '',
            familyName: '',
            active: true,
            roleId: null
        })
        // dynamic update field on list: override object
        this.setState(obj)
    }

    onSave(row, index) {
        console.log('on save')
        // new | edit
        let method = 'POST'
        if (!row.new) method = 'PATCH'

        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/user',
                    method: method,
                    data: {
                        active: row.active ? 1 : 0,
                        familyName: row.familyName,
                        name: row.name,
                        username: row.username,
                        roleId: row.roleId
                    }
                })
                .then(response => {
                    console.log('on save response', response)
                    if (response.data && response.data.status === 'FAILURE') {
                        alert('Error: ' + response.data.messages)
                        return
                    }
                    let data = this.state.data
                    //data.subPartners[index].new = false;
                    data[index] = response.data.body
                    this.setState({ data: data, loading: false })
                })
        })
    }

    onRemove(row, index) {
        console.log('onSubPartnersRemove')
        this.setState({ loading: true }, () => {
            axios.request({ url: '/user', method: 'DELETE', data: { username: row.username } }).then(response => {
                console.log('on remove response', response)
                let data = this.state.data
                data.splice(index, 1)
                this.setState({ data: data, loading: false })
            })
        })
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <Multi>
                        {!this.state.data ? (
                            <Preloader transparent />
                        ) : (
                            <div className="row">
                                <div className="col-12" style={{ 'margin-bottom': '20px' }}>
                                    <WhiteBox>
                                        <div className="row" style={{ marginTop: '25px' }}>
                                            <div className="col">
                                                <h3>Users</h3>
                                            </div>
                                        </div>
                                        {this.state.loading && <Preloader transparent />}
                                        <UserList
                                            showEdit={this.state.showEdit}
                                            onchange={this.onChange.bind(this)}
                                            onadd={this.onAdd.bind(this)}
                                            onSave={this.onSave.bind(this)}
                                            onRemove={this.onRemove.bind(this)}
                                            list={this.state.data}
                                            roles={this.state.roles}
                                        />
                                    </WhiteBox>
                                </div>
                            </div>
                        )}
                    </Multi>
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Settings)
